// extracted by mini-css-extract-plugin
export var deleteModal = "_hi-0";